﻿export const WORKFLOW_HISTORY_STATUS = {
  rejected: 0,
  approved: 1,
};
